// extracted by mini-css-extract-plugin
module.exports = {"permissions":"role-create-form_permissions__vGobo"};